import useRecursiveBillingSetup from 'dataflow/billingPortal/actions/useRecursiveBillingSetup.actions';
import useReporting from 'dataflow/billingPortal/actions/useReporting.actions';
import { deepCloneArray, isNullUndefined, isArrayNotEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useState } from 'react';

function useData(currentTabId) {
    const { getFullProductDetailList } = useRecursiveBillingSetup();
    const { getLevel1EnabledProductDetailList, getLevel2EnabledProductDetailList, getLevel2CommissionPercentage } = useReporting();

    const {
        fullProductDetailList
    } = useCustomSelector("recursiveBillingSetup");

    const {
        level1EnabledProductDetailList, level2EnabledProductDetailList, 
        addProductLevel1_isSuccessful, level2CommissionPercentage,
        addProductLevel2_isSuccessful,
        deleteProductLevel1_isSuccessful, deleteProductLevel2_isSuccessful,
        updateLevel2CommissionPercentage_isSuccessful,

        getLevel1EnabledProductDetaiList_requesting, getLevel2EnabledProductDetaiList_requesting
    } = useCustomSelector("reporting");

    const [productList, setProductList] = useState();
    const [enabledProductList, setEnabledProductList] = useState();
    const [commission, setCommission] = useState();

    let isNewOutlet = (currentTabId === "newOutlet");
    let enabledList = isNewOutlet? level1EnabledProductDetailList: level2EnabledProductDetailList;
    let addProduct_isSuccessful = isNewOutlet? addProductLevel1_isSuccessful: addProductLevel2_isSuccessful;
    let deleteProduct_isSuccessful = isNewOutlet? deleteProductLevel1_isSuccessful: deleteProductLevel2_isSuccessful;
    let getEnabledProductDetailList = isNewOutlet? getLevel1EnabledProductDetailList: getLevel2EnabledProductDetailList;
    let getEnabledProductDetailList_requesting = isNewOutlet? getLevel1EnabledProductDetaiList_requesting: getLevel2EnabledProductDetaiList_requesting;
    useEffect(() => {
        // Get data initially
        getFullProductDetailList();
    }, []);
    useEffect(() => {
        getEnabledProductDetailList(null, "Dealer");
    }, [currentTabId]);
    useEffect(() => {
        // On Successful update
        if (addProduct_isSuccessful || deleteProduct_isSuccessful) {
            getEnabledProductDetailList(null, "Dealer");
        }
    }, [addProduct_isSuccessful, deleteProduct_isSuccessful]);
    useEffect(() => {
        getLevel2CommissionPercentage("Dealer");
    }, [updateLevel2CommissionPercentage_isSuccessful]);
    useEffect(() => {
        // Initial set
        if (level2CommissionPercentage) setCommission(level2CommissionPercentage);
    }, [level2CommissionPercentage]);

    // Reset commission when tab change.
    useEffect(() => {
        setCommission(level2CommissionPercentage);
    }, [currentTabId]);

    function reformatList(oriList) {
        if (isArrayNotEmpty(oriList) || !productList) {
            // Sort array based on group name
            let originalList = deepCloneArray(oriList);
            originalList.sort((obj1, obj2) => {
                let group1 = obj1?.StockGroup;
                let group2 = obj2?.StockGroup;
                if (group1 > group2 || (group1 && isNullUndefined(group2))) return 1;
                if (group1 < group2 || (group2 && isNullUndefined(group1))) return -1;
                return 0;
            });


            // Group the product details
            let newArray = [];
            originalList.map((obj) => {
                let currentGroup = isArrayNotEmpty(newArray)? newArray[newArray.length - 1]?.label:"";
                let nextgroup = obj?.StockGroup;

                if (currentGroup === nextgroup) {
                    newArray[newArray.length - 1].subList.push({
                        label: obj?.ProductName + " - " + obj?.ProductCode,
                        data: obj?.ProductCode
                    })
                }
                else {
                    newArray.push({
                        label: obj?.StockGroup,
                        subList: [
                            {
                                label: obj?.ProductName + " - " + obj?.ProductCode,
                                data: obj?.ProductCode
                            }
                        ]
                    })
                }
            });

            return newArray;
        }
        return [];
    }
    useEffect(() => {
        // Set enabled list
        if (isArrayNotEmpty(fullProductDetailList)) {
            let formatted_list = isArrayNotEmpty(enabledList)? deepCloneArray(enabledList): [];
            formatted_list.map((details, idx) => {
                for (let i = 0; i < fullProductDetailList.length; i++) {
                    if (details?.ProductCode === fullProductDetailList[i]?.ProductCode &&
                        details?.ProductName === fullProductDetailList[i]?.ProductName) {
    
                        details.StockGroup = fullProductDetailList[i]?.StockGroup;
                        break;
                    }
                }
            })

            setEnabledProductList(reformatList(formatted_list));
        }

        // Set non enabled list
        if (isArrayNotEmpty(fullProductDetailList)) {
            let newList = deepCloneArray(fullProductDetailList);
            for (let j = 0; j < newList.length; j++) {
                let details = newList[j];
                if (isArrayNotEmpty(enabledList)) {
                    for (let i = 0; i < enabledList.length; i++) {
                        if (details?.ProductCode === enabledList[i]?.ProductCode &&
                            details?.ProductName === enabledList[i]?.ProductName) {
        
                            newList.splice(j, 1);
                            j--;
                            break;
                        }
                    }
                }
            }

            setProductList(reformatList(newList));
        }
    }, [JSON.stringify(enabledList), JSON.stringify(fullProductDetailList)]);

    return {
        productList, setProductList, 
        enabledProductList, setEnabledProductList,
        commission, setCommission,

        getEnabledProductDetailList_requesting
    }
}

export default useData;